export const validateBoatLeadForm = (formData) => {
  const errors = {};

  if (!formData.fullName?.trim()) {
    errors.fullName = 'Full Name is required';
  }

  if (!formData.email?.trim()) {
    errors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'Invalid email format';
  }

  if (!formData.phone?.trim()) {
    errors.phone = 'Phone is required';
  } else if (!/^\+?[\d\s-]{10,}$/.test(formData.phone)) {
    errors.phone = 'Invalid phone number';
  }

  if (formData.date && !/^\d{4}-\d{2}-\d{2}$/.test(formData.date)) {
    errors.date = 'Invalid date format (YYYY-MM-DD)';
  }

  return errors;
}; 